<template>
  <div>
    <el-row>
      <el-col style="margin-top: 20px">
        <el-table :data="tableData" border stripe>
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column label="客户名称" prop= "TC_NAME"></el-table-column>
          <el-table-column label="项目点" prop= "PROJECT_NAME"></el-table-column>
          <el-table-column label="档口" prop= "DK_NAME"></el-table-column>
          <el-table-column label="操作" >
            <template slot-scope="scope">
              <el-button v-preventReClick @click="copyOrder(scope.row)" type="text">复制</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 复制订单模态框 -->
    <el-dialog title="复制虚拟订单" center :visible.sync="copyFormVisible" @close="copyFormVisible = false" width="600px">
      <el-form :model="copyForm" ref="copyForm">
        <el-form-item label="日期：" :label-width="formLabelWidth">
          <el-date-picker
            v-model="copyForm.SEND_DAY"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            style="width:80%"
            :picker-options="pickerOptions0"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-preventReClick @click="copyFormVisible = false">取 消</el-button>
        <el-button v-preventReClick @click="submitCopy">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>


import http from "@/assets/common/http";

export default {
  data() {
    return {
      tableData: [],
      copyForm: {},
      copyFormVisible: false,
      formLabelWidth: '110px',
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
    };
  },
  methods: {
    queryData() {
      const params = {
        SERVICE_ID: '10079',
        OTYPE: 1,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.tableData = result;
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    copyOrder(row) {
      this.copyFormVisible = true;
      this.copyForm = row;
    },
    submitCopy() {
      const params = {
        SERVICE_ID: '10079',
        OTYPE: 2,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        DK_ID: this.copyForm.DK_ID,
        OLD_DK_ID: this.copyForm.OLD_ID,
        SEND_DAY: this.copyForm.SEND_DAY,
      };
      http.post(params).then((result) => {
        this.$message.show({
          text: '复制成功',
          type: 'success',
        });
        this.copyFormVisible = false;
        this.queryData();
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
  },
  created() {
    this.queryData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sellOrderManage/copyVirtualOrder.vue